define((require) => {
    "use strict";

    const Marionette                = require("marionette");
    const UserCollection            = require("ui/user/UserCollection");
    const LoggedInUserState         = require("shared/ui/user/LoggedInUserState");
    const Promise                   = require("shared/util/Promise");
    const LoggedIn                  = require("shared/security/LoggedIn");
    const TrafficModel              = require("ui/settings/manageAccount/TrafficModel");
    const ManageAccountSettingsView = require("ui/settings/manageAccount/ManageAccountSettingsView");

    /**
     * <tt>Marionette Controller</tt> for the <tt>ManageAccountView</tt>.
     *
     * Responsible for handling the traffic on the account.
     *
     */
    return Marionette.Controller.extend({

        showManageAccount() {
            const principal = LoggedIn.principal();
            const region = this.options.region;
            const trafficModel = new TrafficModel({companyId: principal.get("companyId")});

            Promise.all([LoggedInUserState.fetchGlobalCollection(UserCollection), trafficModel.fetch()])
                .then((results) => {
                    const [collection] = results;
                    const undeletedUsers = collection.undeletedUsers();

                    region.show(new ManageAccountSettingsView({
                        trafficModel: trafficModel,
                        model:        principal.get("user"),
                        collection:   undeletedUsers,
                        isEditable:   true // any user can change their own name
                    }));
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/manageAccount/ManageAccountController.js